import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as classnames from 'classnames';
var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.render = function () {
        var props = this.props;
        var defaultClasses = namespacedClassnames('container', { secondary: props.secondary });
        var classNames = classnames(defaultClasses, props.className);
        return React.createElement("div", { className: classNames }, props.children);
    };
    return Container;
}(React.PureComponent));
export { Container };
//# sourceMappingURL=container.js.map